import Alert, { type AlertColor } from '@mui/material/Alert';
import Snackbar, { type SnackbarProps } from '@mui/material/Snackbar';
import type { ReactNode } from 'react';

export interface ToastState {
  message: string;
  severity?: AlertColor;
}

interface ToastProps extends Omit<SnackbarProps, 'onClose' | 'children' | 'message' | 'open'> {
  toast: ToastState | null;
  onClose: () => void;
}

export function Toast({
  toast,
  onClose,
  autoHideDuration = 3000,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' },
  ...props
}: ToastProps): ReactNode {
  return (
    <Snackbar
      open={toast !== null}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      {...props}
    >
      <Alert
        onClose={onClose}
        severity={toast?.severity ?? 'info'}
        sx={{
          borderRadius: 1,
          fontSize: 13,
          fontWeight: 600,
          alignItems: 'center',
        }}
      >
        {toast?.message}
      </Alert>
    </Snackbar>
  );
}
